module.exports = __webpack_public_path__ + "static/media/24.7b8e7870.png";